import Vue from "vue";
import VueI18n from "vue-i18n";

import en from "../locales/v3/en.json";
import ko from "../locales/v3/ko.json";

Vue.use(VueI18n);

const messages = {
  en,
  ko,
};

const i18n = new VueI18n({
  locale: localStorage.getItem("selectedLanguage") || "en", // default language
  fallbackLocale: "en",
  messages,
});

export function $t(key, params) {
  return i18n.t(key, params);
}

export function $tc(key, params) {
  return i18n.tc(key, params);
}

export default i18n;
